import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-permissions";
import ContainersConfigurations from "@/components/logistics/containers/containers-configurations";

export const Route = createFileRoute(
  "/_authenticated/settings/_layout/containers",
)({
  component: ContainersPage,
});

function ContainersPage() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "containers", actions: ["read", "update"] }]}
    >
      <ContainersConfigurations />
    </RouteGuardPermissions>
  );
}
